import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import Link from '@material-ui/core/Link';
import MenuIcon from '@material-ui/icons/Menu';
//import NotificationsIcon from '@material-ui/icons/Notifications';
import ShareIcon from '@material-ui/icons/Share';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import styles from '../../utils/navTabStyle';
import Share from '../sharemodal/Share';

const useStyles = makeStyles(theme => ({
  ...styles
}))
const MainHeader = (props) => {
  const { onSidebarOpen } = props;
  const classes = useStyles();
 
  return (
    <React.Fragment>
      
      <AppBar color="primary" position="sticky" elevation={0}>
        <Toolbar>
          <Grid container spacing={1} alignItems="center">
            <Hidden lgUp>
              <Grid item>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={onSidebarOpen}
                  className={classes.menuButton}
                >
                  <MenuIcon />
                </IconButton>
              </Grid>
            </Hidden>
            <Grid item xs />
            <Grid item>
              <Link className={classes.link} href="/" variant="body2">
              
                Databode
                
              </Link>
            </Grid>
            <Grid item>
              <Share />
            </Grid>
            
          </Grid>
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
}

MainHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  onDrawerToggle: PropTypes.func.isRequired,
};

export default MainHeader;
